<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              Facilities
          </v-card-title>
          <v-card-text>
              <v-text-field label="Facility Name" autofocus v-model="activeItem.facility_name"></v-text-field>
              <v-text-field label="Description" autofocus v-model="activeItem.description"></v-text-field>
              <v-text-field type="number" label="Sampling Frequency" v-model.number="activeItem.sampling_freq"></v-text-field>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)" :disabled="!$can('update', 'Facility')">Save</v-btn>
              <v-btn @click="initializeVar(true)">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putFacility} from '../../helper'

  export default {
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem.facility_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
        activeItem: {
          facility_name: '',
          description: '',
          meta: '',
          sampling_freq: '',
          facility_id: null,

        } ,

      }
    },
    methods: {
      initializeVar(close) {
        this.activeItem = {
          facility_name: '',
          description: '',
          meta: '',
          sampling_freq: '',
          facility_id: null,
          }
          if(close) {
              this.dialog = false;
          }
      },
      addRecord (close) {
        putFacility(
          {
            'facility_name': this.activeItem.facility_name,
            'description': this.activeItem.description,
            'meta': this.activeItem.meta,
            'sampling_freq': this.activeItem.sampling_freq,
            'facility_id': this.activeItem.facility_id,
          }
        )
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'FacilityRecordDialog'
  }
</script>

<style scoped>

</style>
